import { AppThunk } from '../../../store/rootReducer';
import { userNameSelector } from '../../auth/selectors/auth.selectors';
import {
  delineationByIdSelector,
  userDelineationSelector,
} from '../selectors/delineation.selectors';
import { DelineationId } from '../types/delineation.type';
import { pickDelineation } from './pick-delineation.thunk';
import { updateUserDelineation } from './update-user-delineation.thunk';

export const importDelineation = (
  delineationId: DelineationId,
): AppThunk => async (dispatch, getState) => {
  const imported = delineationByIdSelector(delineationId)(getState());
  const userName = userNameSelector(getState());

  if (imported == null || imported.waves == null || userName == null) {
    return;
  }

  dispatch(updateUserDelineation(imported.waves));

  const userDelineation = userDelineationSelector(getState());

  if (userDelineation == null) {
    return;
  }

  dispatch(pickDelineation(userDelineation.id));
};
